import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import { ImageAssetFieldsFragmentDoc } from './imageAssetFields.generated';
export type ShopProductFieldsFragment = { __typename?: 'shop_products', id: string, status?: string | null, internal_name?: string | null, reward_id?: string | null, title?: string | null, description?: string | null, subtext?: string | null, badge?: string | null, cta_copy?: string | null, cta_url?: string | null, color_scheme?: string | null, show_for_logged_out?: any | null, desktop_image?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, mobile_image?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null };

export const ShopProductFieldsFragmentDoc = gql`
    fragment ShopProductFields on shop_products {
  id
  status
  internal_name
  reward_id
  title
  description
  subtext
  desktop_image {
    ...ImageAssetFields
  }
  mobile_image {
    ...ImageAssetFields
  }
  badge
  cta_copy
  cta_url
  color_scheme
  show_for_logged_out
}
    ${ImageAssetFieldsFragmentDoc}`;